import { Link, useLocation, useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import Swal from "sweetalert2";
import {
    userMe,
    userLogout
} from "../../config/userApi";

function UserSidebar({ sidebarOpen, setSidebarOpen }) {

  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
        console.log("Logging out user...");

        const response = await userLogout();

        console.log("Logout Status:", response.status);

        const responseText = await response.text();

        console.log("Raw Logout Response:", responseText);

        let data = {};

        try {
            if (responseText) {
                data = JSON.parse(responseText);
            }
        } catch (jsonError) {
            console.error("Logout JSON Parse Error:", jsonError);
        }

        console.log("Logout Response:", data);

        /*
        |--------------------------------------------------------------------------
        | Logout Successful
        |--------------------------------------------------------------------------
        */

        if (response.ok) {

            console.log("✅ User Logged Out Successfully");

            // Close mobile sidebar
            if (setSidebarOpen) {
                setSidebarOpen(false);
            }

            await Swal.fire({
                icon: "success",
                title: "Logged Out",
                text: "You have been logged out successfully.",
                timer: 1200,
                showConfirmButton: false
            });

            // Redirect to Home
            navigate("/");

            return;
        }

        /*
        |--------------------------------------------------------------------------
        | Logout Failed
        |--------------------------------------------------------------------------
        */

        console.error("Logout Failed:", data.message);

        Swal.fire({
            icon: "error",
            title: "Logout Failed",
            text:
                data.message ||
                "Unable to logout. Please try again."
        });

    } catch (error) {

        console.error("Logout Error:", error);

        Swal.fire({
            icon: "error",
            title: "Connection Error",
            text:
                error.message ||
                "Unable to connect with server."
        });
    }
};

  // Active link check
  const isActive = (path) => {
    return location.pathname === path ? "sidebar-link active" : "sidebar-link";
  };

  return (
    <>
      <aside
        className={`user-sidebar ${
          sidebarOpen ? "sidebar-open" : ""
        }`}
      >

        {/* LOGO */}

        <div className="sidebar-logo">

          <div className="logo-icon">
            H
          </div>

          <div>
            <h4>HomoeoAdda</h4>
          </div>

        </div>


        {/* MENU */}

        <div className="sidebar-menu">

          <p className="menu-title">
            MAIN MENU
          </p>


          {/* DASHBOARD */}

          <Link
            to="/dashboard"
            className={isActive("/dashboard")}
            onClick={() => setSidebarOpen(false)}
          >
            <i className="bi bi-grid-1x2-fill"></i>
            <span>Dashboard</span>
          </Link>


          {/* FREE MCQs */}

          <Link
            to="/free-mcq"
            className={isActive("/free-mcq")}
            onClick={() => setSidebarOpen(false)}
          >
            <i className="bi bi-journal-text"></i>
            <span>Free MCQs</span>
          </Link>


          {/* PREMIUM MCQs */}

          <Link
            to="/premium-mcq"
            className={`${isActive("/premium-mcq")} premium-link`}
            onClick={() => setSidebarOpen(false)}
          >
            <i className="bi bi-gem"></i>
            <span>Premium MCQs</span>

            <span className="premium-small">
              PRO
            </span>
          </Link>
          <Link
              to="/prime-paper-category"
              className={`${isActive("/prime-paper-category")} premium-link`}
              onClick={() => setSidebarOpen(false)}
          >
              <i className="bi bi-journal-medical"></i>

              <span>
                  Premium Papers
              </span>

              <span className="premium-small">
                  PRO
              </span>
          </Link>

          {/* MY TESTS */}

          


          {/* RESULTS */}

          


          {/* ACCOUNT */}

          <p className="menu-title second-title">
            ACCOUNT
          </p>


          {/* MY PROFILE */}

          


          {/* SUBSCRIPTION */}

          <Link
            to="/subscription"
            className={`${isActive("/subscription")} premium-menu`}
            onClick={() => setSidebarOpen(false)}
          >
            <i className="bi bi-stars"></i>
            <span>Subscription</span>
          </Link>


          {/* LOGOUT */}

          <button
            className="sidebar-link logout-btn"
            onClick={handleLogout}
          >
            <i className="bi bi-box-arrow-right"></i>
            <span>Logout</span>
          </button>
          <button
            type="button"
            className="sidebar-link"
            onClick={() => navigate("/")}
        >
            <i className="bi bi-house-door"></i>
            <span>Home</span>
        </button>

        </div>

      </aside>


      {/* MOBILE OVERLAY */}

      {sidebarOpen && (

        <div
          className="sidebar-overlay"
          onClick={() => setSidebarOpen(false)}
        ></div>

      )}

    </>
  );
}

export default UserSidebar;